export const setAccessTokenKey = (type) => {
  console.log('accesss', process.env.REACT_APP_CUSTOM_NODE_ENV)
  return `${type.toUpperCase()}-TOKEN-${process.env.REACT_APP_CUSTOM_NODE_ENV.toUpperCase()}`
}

const access_token_key = setAccessTokenKey('OH-ACCESS')
const refresh_token_key = setAccessTokenKey('OH-REFRESH')
const refresh_last_updated_token_key = setAccessTokenKey(
  'OH-REFRESH-LAST-UPDATED'
)
const user_number = setAccessTokenKey('OH-USER-NUMBER')

export default {
  ACCESS_TOKEN_KEY: access_token_key, //'OPENHOUSE-ACCESS-TOKEN-KEY',
  ACTIVE: 'active',
  ADMIN: 'admin',
  ADMIN_LABEL: 'Admin',
  ATTENDANCE: 'attendance',
  ATTENDANCE_LABEL: 'Attendance',
  ATTACH_TRIBE: 'attachTribe',
  BATCH: 'batch',
  BATCH_LABEL: 'Batch',
  BOARD: 'board',
  BOARD_LABEL: 'Board',
  BATCH_SELECTION: 'inventory/BATCH_SELECTION',
  BATCH_DETAILS_MODAL: 'inventory/BATCH_DETAILS_MODAL',
  BATCH_RESELECTION: 'inventory/BATCH_RESELECTION',
  BULK_MESSAGING: 'bulkMessaging',
  BULK_MESSAGING_MESSAGE_VALID: 'bulkMessaging/BULK_MESSAGING_MESSAGE_VALID',
  BULK_MESSAGING_LABEL: 'Bulk Messaging',
  CENTRE: 'centre',
  CLOSE_BULK_MESSAGING_MODAL: 'bulkMessaging/CLOSE_BULK_MESSAGING_MODAL',
  CENTRE_LABEL: 'Centre',
  CHANGE_BATCH: 'CHANGE_BATCH',
  CLUB: 'club',
  CLUB_LABEL: 'Club',
  CLUB_REGISTRATION: 'clubRegistration',
  CLUB_REGISTRATION_LABEL: 'Club Registration',
  CANCELED_MEMBER: 'canceledMember',
  CANCELED_MEMBER_LABEL: 'Cancelled Member',
  CONVERT_N: 'convertN',
  CONVERTED: 'converted',
  COURSE: 'course',
  COURSE_LABEL: 'Course',
  CLOSE_MODAL_FORM: 'CLOSE_MODAL_FORM',
  CUSTOM_PRICING: 'customPricing',
  CUSTOM_PRICING_LABEL: 'Custom Pricing',
  CREATED: 'created',
  DARK: 'dark',
  DATA_DELETED: 'Data Deleted!',
  DATA_SAVED: 'Data Saved! 🥳',
  DISPATCH: 'dispatch',
  DISPATCH_LABEL: 'Dispatch',
  DUE: 'due',
  DUE_LABEL: 'Due Non-member',
  DUE_MEMBER: 'dueMember',
  DUE_MEMBER_LABEL: 'Due Member',
  DUE_TOPUP: 'dueTopup',
  DUE_TOPUP_LABEL: 'Due Recharge',
  DUE_RENEWAL: 'dueRenewal',
  DUE_RENEWAL_LABEL: 'Due Renewal',
  ENROLMENT: 'enrolment',
  ENROLMENT_LABEL: 'Event Enrolments',
  ERROR: 'error',
  ERROR_MESSAGE: 'Server Error Occurred!',
  EVENT: 'event',
  EVENT_LABEL: 'Event',
  EVENT_POSTER: 'event_poster',
  EVENT_REGISTRATION: 'eventRegistration',
  EVENT_REGISTRATION_LABEL: 'Event Registration',
  FILL_ALL_REQUIRED_FIELDS: 'Fill All Required Fields',
  FETCHING: 'fetching',
  IS_SCHEDULING_REQUEST_FINISHED: 'IS_SCHEDULING_REQUEST_FINISHED',
  INVENTORY_SCHEDULES: 'inventorySchedules',
  INDEPENDENT: 'independent',
  INDEPENDENT_LABEL: 'Independent',
  INDEPENDENT_SUMMARY: 'independentSummary',
  INDEPENDENT_SUMMARY_LABEL: 'Teacher Dispatch',
  INDEPENDENT_ONGOING: 'independentOngoing',
  INDEPENDENT_ONGOING_LABEL: 'IndependentOngoing',
  INDEPENDENT_ONGOING_SUMMARY: 'independentOngoingSummary',
  INDEPENDENT_ONGOING_SUMMARY_LABEL: 'Teacher Ongoing Earnings',
  INACTIVE_TRIBE_MEMBERSHIP: 'inactiveMembership',
  INACTIVE_TRIBE_MEMBERSHIP_LABEL: 'Inactive Membership',
  INTERACTION_HISTORY: 'interactionHistory',
  INTERACTION_HISTORY_LABEL: 'Interaction',
  INVENTORY_BOOKING_SUCCESS: 'INVENTORY_BOOKING_SUCCESS',
  INVENTORY_BOOKING_ERROR: 'INVENTORY_BOOKING_ERROR',
  INFO: 'info',
  LIGHT: 'light',
  MOMENTS: 'moments',
  MODAL_FORM_SAVE_ERROR: 'MODAL_FORM_SAVE_ERROR',
  MAKE_UP_SESSION: 'makeUpSession',
  MAKE_UP_SESSION_LABEL: 'Make-Up Session',
  EXPLORE_SESSION: 'exploreSession',
  EXPLORE_SESSION_LABEL: 'Explore Session',
  TODDLER_CLUB_SESSION: 'toddlerClubSession',
  TODDLER_CLUB_SESSION_LABEL: 'Toddler Club Sessions',
  EXPLORE_ENROLMENT: 'exploreEnrolment',
  EXPLORE_ENROLMENT_LABEL: 'Explore Enrolments',
  TODDLER_CLUB_ENROLMENT: 'toddlerClubEnrolment',
  TODDLER_CLUB_ENROLMENT_LABEL: 'Toddler Club Enrolments',
  EXCEL_ENROLMENT: 'excelEnrolment',
  EXCEL_ENROLMENT_LABEL: 'Excel Enrolments',
  PSAC_ENROLMENT: 'psacEnrolment',
  PSAC_ENROLMENT_LABEL: 'school & care Enrolments',
  MEMBERSHIP: 'membership',
  MEMBERSHIP_LABEL: 'Membership',
  MOCK_TEST_REPORT_CARD: 'mockTestReportCard',
  MOCK_TEST_REPORT_CARD_LABEL: 'Students Mock Test Reports',
  MOCK_TEST_THUMBNAIL: 'mockThumbnail',
  MOCK_TEST_PDF: 'mockPDF',
  NETWORK_ERROR: 'Network Error',
  OPENBOOK: 'openbook',
  OTHERS: 'others',
  PAPER: 'paper',
  PAPER_LABEL: 'Paper',
  PRICING: 'pricing',
  PRICING_LABEL: 'Pricing',
  PAGE_NO: 'PAGE_NO',
  PAID: 'paid',
  PAID_LABEL: 'Paid Non-Member',
  PAID_MEMBER: 'paidMember',
  PAID_MEMBER_LABEL: 'Paid Member',
  PAID_TOPUP: 'paidTopup',
  PAID_TOPUP_LABEL: 'Paid Recharge',
  PAID_RENEWAL: 'paidRenewal',
  PAID_RENEWAL_LABEL: 'Paid Renewal',
  PAUSED: 'paused',
  PAUSED_MEMBER: 'pausedMember',
  PAUSED_MEMBER_LABEL: 'Paused Member',
  PARENT: 'parent',
  PARENT_LABEL: 'Parent',
  PRORATA: 'prorata',
  PRORATA_LABEL: 'Pro Rata',
  QUEUED: 'queued',
  REMOVE_SELECTED_ROWS: 'REMOVE_SELECTED_ROWS',
  REFETCHING_STOP: 'REFETCHING_STOP',
  REFERRAL_CODE: 'referralCode',
  REFERRAL_CODE_LABEL: 'Referral Code',
  REFRESH_TOKEN_KEY: refresh_token_key, //'OPENHOUSE-REFRESH-TOKEN-KEY',
  REFRESH_TOKEN_LAST_UPDATED: refresh_last_updated_token_key, //'OPENHOUSE-REFRESH-TOKEN-LAST-UPDATED',
  REMOVE_ALL_FILTERS: 'REMOVE_ALL_FILTERS',
  REMOVED: 'removed',
  // Preschool curriculum (Phase 5) — see
  // new-code/docs/weekly-skills-migration/phase-5-admin-portal/
  PRESCHOOL_SKILL: 'preschoolSkill',
  PRESCHOOL_SKILL_LABEL: 'Preschool Skill',
  // Lesson Planner (EarlyLearn)
  PLANNER_GRADE_GROUP: 'plannerGradeGroup',
  PLANNER_GRADE_GROUP_LABEL: 'Planner Grade Group',
  PLANNER_SUBJECT: 'plannerSubject',
  PLANNER_SUBJECT_LABEL: 'Planner Subject',
  PLANNER_LAYOUT: 'plannerLayout',
  PLANNER_LAYOUT_LABEL: 'Planner Layout',
  PRESCHOOL_WEEKLY_THEME: 'preschoolWeeklyTheme',
  PRESCHOOL_WEEKLY_THEME_LABEL: 'Preschool Weekly Theme',
  PRESCHOOL_WEEKLY_SKILL_PLAN: 'preschoolWeeklySkillPlan',
  PRESCHOOL_WEEKLY_SKILL_PLAN_LABEL: 'Preschool Weekly Skill Plan',
  PRESCHOOL_MONTHLY_THEME: 'preschoolMonthlyTheme',
  PRESCHOOL_MONTHLY_THEME_LABEL: 'Preschool Monthly Theme',
  PRESCHOOL_ANNUAL_LO: 'preschoolAnnualLo',
  PRESCHOOL_ANNUAL_LO_LABEL: 'Preschool Annual LO',
  PRESCHOOL_SPIRAL_LO: 'preschoolSpiralLo',
  PRESCHOOL_SPIRAL_LO_LABEL: 'Preschool Spiral LO',
  ROOM: 'room',
  ROOM_LABEL: 'Room',
  REPORT_CARD: 'reportCard',
  REPORT_CARD_LABEL: 'Student Reports',
  STUDENT: 'student',
  STUDENT_LABEL: 'Student',
  STANDARD: 'standard',
  STANDARD_LABEL: 'Standard',
  STUDENT_SUMMARY: 'studentSummary',
  STUDENT_SUMMARY_LABEL: 'Student Summary',
  SUBJECT: 'subject',
  SUBJECT_LABEL: 'Subject',
  PLAY_DATE_SUBJECT: 'playdateSubject',
  PLAY_DATE_SUBJECT_LABEL: 'Playdate Subject',
  TODDLER_CLUB_SUBJECT: 'toddlerClubSubject',
  TODDLER_CLUB_SUBJECT_LABEL: 'Toddler Club Subject',
  SUBJECT_CATEGORY: 'subjectCategory',
  SUBJECT_CATEGORY_LABEL: 'Subject Category',
  SUCCESS: 'success',
  SUPERPROVIDER: 'superprovider',
  SUPERPROVIDER_LABEL: 'Superprovider',
  SUPERPROVIDER_SUMMARY: 'superproviderSummary',
  SUPERPROVIDER_SUMMARY_LABEL: 'Superprovider Summary',
  SCHOOL_ATTENDANCE: 'school_attendance',
  TEACHER: 'teacher',
  TEACHER_LABEL: 'Teacher',
  TEACHER_SUMMARY: 'teacherSummary',
  TEACHER_SUMMARY_LABEL: 'Teacher Summary',
  TERMINATE_ENROLMENT: 'TERMINATE_ENROLMENT',
  TICKET: 'ticket',
  TICKET_LABEL: 'Ticket',
  TRIBE: 'tribe',
  TRIBE_LABEL: 'Tribe',
  TRIAL_SESSIONS: 'trialSessions',
  TRIAL_SESSIONS_LABEL: 'Trial & Drop-In Care Sessions',
  TRIBE_SELECTION: 'tribe_selection',
  UPDATED: 'updated',
  USER: 'user',
  USER_NUMBER: user_number, //'OPENHOUSE-USER-NUMBER',
  UPCOMING: 'upcoming',
  WAITLIST_OTHERS: 'waitlistOthers',
  WAITLIST_OTHERS_LABEL: 'Other Waitlists',
  WAITLIST_CONVERTED: 'waitlistConverted',
  WAITLIST_CONVERTED_LABEL: 'Converted Members',
  WAITLIST_QUEUED: 'waitlistQueued',
  WAITLIST_QUEUED_LABEL: 'Registrations',
  WAITLIST_TRIBE_SELECTION: 'waitlistTribeSelection',
  WAITLIST_TRIBE_SELECTION_LABEL: 'Tribe selection',
  SLIDER_OPENER: 'sliderOpener',
  EXISTING_USER_ERROR: 'Existing User Error',
  SCHEDULE_SESSION_ACTIVITY: 'scheduleSessionActivity',
  ORDERS: 'orders',
  ORDERS_LABEL: 'Orders',
  PLAY_CARE_ORDERS: 'playCareOrders',
  PLAY_CARE_ORDERS_LABEL: 'Drop-In Care Orders',
  ACTIVE_CARE_ORDERS: 'activeCareOrders',
  ACTIVE_CARE_ORDERS_LABEL: 'Active Care Orders',
  ACTIVE_CARE_ENROLMENTS: 'activeCareEnrolments',
  ACTIVE_CARE_ENROLMENTS_LABEL: 'Active Care Enrolments',
  INSTALLMENT_ORDERS: 'installmentOrders',
  INSTALLMENT_ORDERS_LABEL: 'Instalment Orders',
  TEACHER_LIST: 'teacherList',
  STUDENT_LIST: 'studentList',
  PARENT_LIST: 'parentList',
  CHAT_MESSAGES: 'chatMessages',
  PARENT_CHAT_MESSAGES: 'parentChatMessages',
  CHAT_MESSAGES_HEADER: 'chatMessagesHeader',
  PARENT_CHAT_MESSAGES_HEADER: 'parentChatMessagesHeader',
  ANNOUNCEMENT: 'announcement',
  ANNOUNCEMENT_LABEL: 'Announcement'
}

export const products = ['inventory', 'members_app', 'website']

export const DUMMY_PARENT_LABEL =
  'This is a paused/ churned member. Make them active without sending them a payment link'

export const USER_EXISTS_ERROR_MESSAGE =
  'This number already exists. Proceeding will delete the existing user and then update the number. Are you sure you want to proceed?'

export const FORCE_UPDATE_ERROR_MESSAGE =
  'This number cannot be updated as it already exists in the system. Do you wish to submit a deletion request?'

export const RECHARGE_REASON = {
  REFERRAL: 'Referral',
  REFUND: 'Refund',
  RECHARGE: 'Recharge',
  WALLET_TRANSFER: 'Wallet Transfer'
}

export const POLICY_ACKNOWLEDGMENT_ALFRED =
  'I confirm that I’ve informed the parent about all the Openhouse policies (subscription, refund, make-up classes), and they have agreed.'

export const USER_STATUS = {
  NEW_LEAD: 'new',
  TRIAL_BOOKED: 'trial_booked',
  CUSTOMER: 'customer'
}

export const SUPPORT_FORM_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSe24o1oYeXbYSjki5lxiO1JpJU1Q2_96dh5a0LQNkOSDc-t4w/viewform'

export const EXCLUDE_FROM_OPENDAY_COURSE_ID = [
  '31101bc7-d9d0-4f30-af94-e4fbaec28fd2',
  'f5c14111-46c1-43c9-8b62-2f2efed9d35d'
]

export const TICKET_STATUS_OPTIONS = {
  TO_BE_PICKED: 'To be picked',
  IN_PROGRESS_CENTRE: 'In Progress Centre',
  IN_PROGRESS_CORPORATE: 'In Progress Corporate',
  RESOLVED: 'Resolved'
}

export const ANNOUNCEMENT_TYPE_SELECT_OPTIONS = {
  General: 'Miscellaneous',
  Trial: 'Trial',
  Playdate: 'Playdate'
}

export const ANNOUNCEMENT_STATUS_OPTIONS = {
  Active: 'active',
  Paused: 'paused',
  Lapsed: 'lapsed',
  Upcoming: 'upcoming'
}

export const ANNOUNCEMENT_TYPE_KEYS = {
  MISCELLANEOUS: 'General',
  TRIAL: 'Trial',
  PLAYDATE: 'Playdate'
}

export const ANNOUNCEMENT_TYPES = Object.values(ANNOUNCEMENT_TYPE_KEYS)

export const FOLLOW_UP_DATE_MESSAGE =
  'The follow-up date for this ticket is in future, and marking this as resolved will change it to today. Make sure that the follow-up was done with the parent.'

export const CARTV2_TYPE = {
  TOPUP: 'topup',
  TOPUP_BOOKING: 'topup_booking',
  BOOKING: 'booking'
}

export const SUBSCRIPTION_STATUSES = {
  DISCOVERY_UPCOMING: 'discovery_upcoming', //upcoming
  DISCOVERING: 'discovering', //active
  DISCOVERED: 'discovered', //inactive
  SUBSCRIPTION_UPCOMING: 'subscription_upcoming', //upcoming
  SUBSCRIBED: 'subscribed', //active
  PAUSED: 'paused', //active
  UNSUBSCRIBED: 'unsubscribed' //inactive
}

export const SUBSCRIPTION_STATUS_MAP = {
  active: [
    SUBSCRIPTION_STATUSES.DISCOVERING,
    SUBSCRIPTION_STATUSES.SUBSCRIBED,
    SUBSCRIPTION_STATUSES.PAUSED
  ],
  upcoming: [
    SUBSCRIPTION_STATUSES.DISCOVERY_UPCOMING,
    SUBSCRIPTION_STATUSES.SUBSCRIPTION_UPCOMING
  ],
  inactive: [
    SUBSCRIPTION_STATUSES.DISCOVERED,
    SUBSCRIPTION_STATUSES.UNSUBSCRIBED
  ]
}

export const OVERRIDE_9K_NUMBERS = [
  '7872761120', //SOUNAK
  '9654653076', //NIKHIL,
  '7717775805', //ARYAMAN,
  '9830072834', //AASTHA
  '8870541311', //SHRUTI S
  '8901157388', //LAKSHAY N
  '9359113081', //Mihir Mehta
  '8638269911', //Sabina Rahman
  '9562238983', //Safoora Usman
  '9930286336', //Aswathi Nambiar
  '8787546826', //Sneha Sinha
  '9739063403', //Kruthi Prakash
  '9677213613', //Ekta Watwani
  '8847611632', //Vaibhav Sarkar,
  '7439671460', //Swagata Maiti
  '7022140804', //Dhirendra Pallavi
  '8197649947', //Manjushree Mahadev
  '8017092586', // Krithi Rebello
  '6366274141', //Varsha
  '9591753841', //Sejal
  '9342130458' //Archeetha
]

// Feature 4 — OVERRIDE_ADDITIONAL_DISCOUNT_NUMBERS removed. The discount
// authority whitelist now lives in the backend AppConfig row
// `DISCOUNT_AUTHORIZED_PHONE_NUMBERS`, exposed via the /base/me endpoint's
// can_apply_custom_discount flag and re-checked on cart submission. The
// initial seed of the AppConfig list should mirror the original entries
// (Charmi, Mukarram, Satyacharan, ShrutiS, Madhurya, Aayushmaan) — applied
// via Django admin in the cutover deploy.
